<template>
  <div v-html="content"></div>
  <!-- <div class="sitemap-box" style="display: flex;flex-direction: column;align-items: center;margin-bottom: 2rem;">
        <div style="margin-top: 2.25rem;font-size: 2rem;line-height: 2rem;font-weight: bold;color: #B62D2E;">{{ $t('other.sitemap') }}</div>
        <div style="display: flex;margin-top:0.5rem;margin-bottom:5rem;">
            <span style="width: 1rem;height: 1rem;background:#B62D2E;border-radius: 50%;margin:0 0.5rem;"></span>
            <span style="width: 1rem;height: 1rem;background:#DE5934;border-radius: 50%;margin:0 0.5rem;"></span>
            <span style="width: 1rem;height: 1rem;background:#F1AA55;border-radius: 50%;margin:0 0.5rem;"></span>
        </div>
        <div style="margin-bottom:2rem;font-size:2rem;font-weight:bold;">{{ $t('other.sitemapText') }}</div>
        <div @click="onHome" style="margin: 1rem;cursor: pointer;">{{ $t('other.home') }}</div>
        <div @click="onAbout" style="margin: 1rem;cursor: pointer;">{{ $t('other.about') }}</div>
        <div @click="onPlatform" style="margin: 1rem;cursor: pointer;">{{ $t('other.platform') }}</div>
        <div @click="onFaq" style="margin: 1rem;cursor: pointer;">{{ $t('other.faq') }}</div>
        <div @click="onContact" style="margin: 1rem;cursor: pointer;">{{ $t('other.contact') }}</div>
    </div> -->
</template>

<script>
export default {
  data() {
    return {
      content: "",
    };
  },
  watch: {
    "$store.getters.language": {
      handler(v) {
        this.$nextTick(() => {
          if (v == "en")
            this.content =
              '<div style="display: flex; flex-direction: column; align-items: center;margin-bottom: 2rem;"><div style="margin-top: 2.25rem;font-size: 2rem;line-height: 2rem;font-weight: bold;color: rgb(182, 45, 46);">Sitemap</div><div style="display: flex; margin-top: 0.5rem; margin-bottom: 1rem"><span style="width: 1rem;height: 1rem;background: rgb(182, 45, 46);border-radius: 50%;margin: 0px 0.5rem;"></span><span style="width: 1rem;height: 1rem;background: rgb(222, 89, 52);border-radius: 50%;margin: 0px 0.5rem;"></span><span style="width: 1rem;height: 1rem;background: rgb(241, 170, 85);border-radius: 50%;margin: 0px 0.5rem;"></span></div><div style="margin-bottom: 2rem;font-size: 2rem;font-weight: bold;">MathConcept Online</div><div onclick="onHome()" style="margin: 1rem;cursor: pointer;">Home</div><div onclick="onAbout()" style="margin: 1rem;cursor: pointer;">About Us</div><div onclick="onPlatform()" style="margin: 1rem;cursor: pointer;">Online Learning</div><div onclick="onFaq()" style="margin: 1rem;cursor: pointer;">FAQ</div><div onclick="onContact()" style="margin: 1rem;cursor: pointer;">Contact Us</div></div>';
          else
            this.content =
              '<div style="display: flex; flex-direction: column; align-items: center;margin-bottom: 2rem;"><div style="margin-top: 2.25rem;font-size: 2rem;line-height: 2rem;font-weight: bold;color: rgb(182, 45, 46);">網頁指南</div><div style="display: flex; margin-top: 0.5rem; margin-bottom: 1rem"><span style="width: 1rem;height: 1rem;background: rgb(182, 45, 46);border-radius: 50%;margin: 0px 0.5rem;"></span><span style="width: 1rem;height: 1rem;background: rgb(222, 89, 52);border-radius: 50%;margin: 0px 0.5rem;"></span><span style="width: 1rem;height: 1rem;background: rgb(241, 170, 85);border-radius: 50%;margin: 0px 0.5rem;"></span></div><div style="margin-bottom: 2rem;font-size: 2rem;font-weight: bold;">MathConcept Online</div><div onclick="onHome()" style="margin: 1rem;cursor: pointer;">主頁</div><div onclick="onAbout()" style="margin: 1rem;cursor: pointer;">關於我們</div><div onclick="onPlatform()" style="margin: 1rem;cursor: pointer;">網上學習平台</div><div onclick="onFaq()" style="margin: 1rem;cursor: pointer;">常見問題</div><div onclick="onContact()" style="margin: 1rem;cursor: pointer;">聯絡我們</div></div>';
        });

        this.$forceUpdate();
      },
      deep: true,
      immediate: true,
    },
  },
  //   mounted() {
  //     this.content =
  //       '<div style="display: flex; flex-direction: column; align-items: center;margin-bottom: 2rem;"><div style="margin-top: 2.25rem;font-size: 2rem;line-height: 2rem;font-weight: bold;color: rgb(182, 45, 46);">網頁指南</div><div style="display: flex; margin-top: 0.5rem; margin-bottom: 1rem"><span style="width: 1rem;height: 1rem;background: rgb(182, 45, 46);border-radius: 50%;margin: 0px 0.5rem;"></span><span style="width: 1rem;height: 1rem;background: rgb(222, 89, 52);border-radius: 50%;margin: 0px 0.5rem;"></span><span style="width: 1rem;height: 1rem;background: rgb(241, 170, 85);border-radius: 50%;margin: 0px 0.5rem;"></span></div><div style="margin-bottom: 2rem;font-size: 2rem;font-weight: bold;">MathConcept Online</div><div onclick="onHome()" style="margin: 1rem;cursor: pointer;">主頁</div><div onclick="onAbout()" style="margin: 1rem;cursor: pointer;">關於我們</div><div onclick="onPlatform()" style="margin: 1rem;cursor: pointer;">網上學習平台</div><div onclick="onFaq()" style="margin: 1rem;cursor: pointer;">常見問題</div><div onclick="onContact()" style="margin: 1rem;cursor: pointer;">聯絡我們</div></div>';
  //   },
  created() {
    window.onHome = this.onHome;
    window.onAbout = this.onAbout;
    window.onPlatform = this.onPlatform;
    window.onFaq = this.onFaq;
    window.onContact = this.onContact;
  },
  methods: {
    onHome() {
      if (
        this.$route.path != "/home" &&
        this.$route.path != "/studentProgramme"
      ) {
        if (this.userInfo.roleName !== this.roleNameStudent) {
          this.$router.push({ name: "home" });
        } else {
          this.$router.push({ path: "/studentProgramme" });
        }
      }
    },
    onAbout() {
      this.$router.push({ name: "about" });
    },
    onPlatform() {
      this.$router.push({ name: "platform" });
    },
    onFaq() {
      this.$router.push({ name: "faq" });
    },
    onContact() {
      this.$router.push({ name: "contact" });
    },
  },
};
</script>

<style lang="scss" scoped>
/*
.sitemap-box{
    margin:0 14vw;
}

@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
    .sitemap-box{
        margin:0 1.25rem 2rem;
    }
}*/
</style>
